'use strict';
define([
], function () {
    return {
        /*eslint-disable*/
        init: function () {
            this.dashboard_housing = this.dashboard_housing.bind(this);
            this.flikerless = this.flikerless.bind(this);
            this.timer = window.setInterval(this.flikerless, 500);
            this.counter = 0;
        },
        flikerless: function () {
            this.counter = this.counter + 1;
            if (document.querySelector('.execute_dashboard')) {
                this.dashboard_housing();
                window.clearInterval(this.timer);
            }
            if (this.counter === 16) {
                window.clearInterval(this.timer);
            }
        },
        dashboard_housing: function () {
            /* slight timeout function delay to allow for the user cookie data to be read by the browser*/
            setTimeout(function () {
                if (document.querySelector("[class*='show_dashboard'")) {
                    /* console.log('IF statement check - if at least one of the cards is ready to show, the script will continue - dashboard housing');
                    create #home_dashboard as a variable  */
                    var home_dashboard = document.querySelector('#home_dashboard');
                    home_dashboard.classList.remove('hide');
                    /* create .page__site-stripe as a variable*/
                    var page__site_stripe = window.NavDashboardPos ? window.NavDashboardPos : document.querySelector('.page__site-stripe');
                    page__site_stripe = page__site_stripe ? page__site_stripe : document.querySelector('.promo-strip');
                    var pageType = document.querySelector('#pageType');
                    if (!page__site_stripe && pageType && pageType.innerText && pageType.innerText.trim() === 'PDP') {
                        page__site_stripe = document.querySelector('.header.navigation-common-hdr-main ~ .row');
                    }
                    if (page__site_stripe) {
                        /* moves #home_dashboard into .page__site-stripe*/
                        page__site_stripe.after(home_dashboard);
                    }

                    /* tales the users name/welcome message and stores into a variable*/
                    var user_first_name = document.querySelector('#userNameText').textContent;
                    /* places the welcome message into an element*/
                    var welcome_message = document.querySelector('.navigation-welcome_message');
                    welcome_message.textContent = 'Welcome back, ' + user_first_name;
                    /* reveals the homepage dashboard block*/
                    setTimeout(function () {
                        home_dashboard.classList.add('navigation-reveal_home_dashboard');
                    }, 1000);
                    /* necessary functions/steps to make the dashboard smoothly transition into the canvas due to the way that Target loads late*/
                    setTimeout(function () {
                        var white_mask = document.querySelector('.white_mask');
                        white_mask.classList.add('remove_white_mask');
                        home_dashboard.classList.add('lift_home_dashboard');
                        welcome_message.classList.add('welcome_message_reveal');
                    }, 1250);
                    /* dashboard bug fix*/
                    setTimeout(function () {
                        var svg_bug_fix = document.querySelector('#home_dashboard .inner ul li svg');
                        svg_bug_fix.classList.add('relative');
                    }, 1500);
                }/* else { console.log('Neither of the dashboard cards are qualified for the user - dashboard housing'); }*/
            }, 1);

            /* moves #dashboard_sparks_card into #dashboard_offers*/
            setTimeout(function () {
                var dashboard_offers = document.querySelector('#dashboard_offers');
                var dashboard_sparks_card = document.querySelector('#dashboard_sparks_card');
                var close_sparks_card = document.querySelector('#close_sparks_card')
                if (dashboard_offers && dashboard_sparks_card && close_sparks_card) {
                    dashboard_offers.insertBefore(dashboard_sparks_card, close_sparks_card);
                    dashboard_sparks_card.classList.add('show_important');
                }
            }, 500);
            /* moves #dashboard_basket_btn into #dashboard_basket*/
            setTimeout(function () {
                var dashboard_basket = document.querySelector('#dashboard_basket');
                var dashboard_basket_card = document.querySelector('#dashboard_basket_btn');
                var close_basket_card = document.querySelector('#close_basket_card');
                if (dashboard_basket && dashboard_basket_card && close_basket_card) {
                    dashboard_basket.insertBefore(dashboard_basket_card, close_basket_card);
                    dashboard_basket_card.classList.add('show_important');
                }
            }, 500);
            /* moves #dashboard_app_download_card into #dashboard_app_download*/
            setTimeout(function () {
                if ('#dashboard_app_download_card') {
                    /* console.log('#dashboard_app_download_card is present and will now be moved into the dashboard housing');*/
                    var dashboard_app_download = document.querySelector('#dashboard_app_download');
                    var dashboard_app_download_card = document.querySelector('#dashboard_app_download_card');
                    var close_app_download_card = document.querySelector('#close_app_download_card');
                    if (dashboard_app_download && dashboard_app_download_card && close_app_download_card) {
                        dashboard_app_download.insertBefore(dashboard_app_download_card, close_app_download_card);
                        dashboard_app_download_card.classList.add('show_important');
                    }
                }
            }, 500);
            /* moves #dashboard_card_four_card into #dashboard_item_four*/
            setTimeout(function () {
                if ('#dashboard_card_four') {
                    /* console.log('#dashboard_card_four is present and will now be moved into the dashboard housing');*/
                    var dashboard_item_four = document.querySelector('#dashboard_item_four');
                    var dashboard_card_four = document.querySelector('#dashboard_card_four');
                    var close_dashboard_item_four = document.querySelector('#close_dashboard_item_four');

                    if (dashboard_item_four && dashboard_card_four && close_dashboard_item_four) {
                        dashboard_item_four.insertBefore(dashboard_card_four, close_dashboard_item_four);
                        dashboard_card_four.classList.add('show_important');
                    }
                }
            }, 500);
            /* moves #dashboard_card_five_card into #dashboard_item_five*/
            setTimeout(function () {
                if ('#dashboard_card_five') {
                    /*console.log('#dashboard_card_five is present and will now be moved into the dashboard housing');*/
                    var dashboard_item_five = document.querySelector('#dashboard_item_five');
                    var dashboard_card_five = document.querySelector('#dashboard_card_five');
                    var close_dashboard_item_five = document.querySelector('#close_dashboard_item_five');
                    if (dashboard_item_five && dashboard_card_five && close_dashboard_item_five) {
                        dashboard_item_five.insertBefore(dashboard_card_five, close_dashboard_item_five);
                        dashboard_card_five.classList.add('show_important');
                    }
                }
            }, 500);
            /* moves #dashboard_card_six_card into #dashboard_item_six*/
            setTimeout(function () {
                if ('#dashboard_card_six') {
                    /*console.log('#dashboard_card_six is present and will now be moved into the dashboard housing');*/
                    var dashboard_item_six = document.querySelector('#dashboard_item_six');
                    var dashboard_card_six = document.querySelector('#dashboard_card_six');
                    var close_dashboard_item_six = document.querySelector('#close_dashboard_item_six');
                    if (dashboard_item_six && dashboard_card_six && close_dashboard_item_six) {
                        dashboard_item_six.insertBefore(dashboard_card_six, close_dashboard_item_six);
                        dashboard_card_six.classList.add('show_important');
                    }
                }
            }, 500);
            /* moves #dashboard_card_seven_card into #dashboard_item_seven*/
            setTimeout(function () {
                if ('#dashboard_card_seven') {
                    /*console.log('#dashboard_card_seven is present and will now be moved into the dashboard housing');*/
                    var dashboard_item_seven = document.querySelector('#dashboard_item_seven');
                    var dashboard_card_seven = document.querySelector('#dashboard_card_seven');
                    var close_dashboard_item_seven = document.querySelector('#close_dashboard_item_seven');
                    if (dashboard_item_seven && dashboard_card_seven && close_dashboard_item_seven) {
                        dashboard_item_seven.insertBefore(dashboard_card_seven, close_dashboard_item_seven);
                        dashboard_card_seven.classList.add('show_important');
                    }
                }
            }, 500);
            /* moves #dashboard_card_eight_card into #dashboard_item_eight*/
            setTimeout(function () {
                if ('#dashboard_card_eight') {
                    /*console.log('#dashboard_card_eight is present and will now be moved into the dashboard housing');*/
                    var dashboard_item_eight = document.querySelector('#dashboard_item_eight');
                    var dashboard_card_eight = document.querySelector('#dashboard_card_eight');
                    var close_dashboard_item_eight = document.querySelector('#close_dashboard_item_eight');
                    if (dashboard_item_eight && dashboard_card_eight && close_dashboard_item_eight) {
                        dashboard_item_eight.insertBefore(dashboard_card_eight, close_dashboard_item_eight);
                        dashboard_card_eight.classList.add('show_important');
                    }
                }
            }, 500);
            /* moves #dashboard_card_nine_card into #dashboard_item_nine*/
            setTimeout(function () {
                if ('#dashboard_card_nine') {
                    /*console.log('#dashboard_card_nine is present and will now be moved into the dashboard housing');*/
                    var dashboard_item_nine = document.querySelector('#dashboard_item_nine');
                    var dashboard_card_nine = document.querySelector('#dashboard_card_nine');
                    var close_dashboard_item_nine = document.querySelector('#close_dashboard_item_nine');
                    if (dashboard_item_nine && dashboard_card_nine && close_dashboard_item_nine) {
                        dashboard_item_nine.insertBefore(dashboard_card_nine, close_dashboard_item_nine);
                        dashboard_card_nine.classList.add('show_important');
                    }
                }
            }, 500);
            /* moves #dashboard_card_ten_card into #dashboard_item_ten*/
            setTimeout(function () {
                if ('#dashboard_card_ten') {
                    /*console.log('#dashboard_card_ten is present and will now be moved into the dashboard housing');*/
                    var dashboard_item_ten = document.querySelector('#dashboard_item_ten');
                    var dashboard_card_ten = document.querySelector('#dashboard_card_ten');
                    var close_dashboard_item_ten = document.querySelector('#close_dashboard_item_ten');
                    if (dashboard_item_ten && dashboard_card_ten && close_dashboard_item_ten) {
                        dashboard_item_ten.insertBefore(dashboard_card_ten, close_dashboard_item_ten);
                        dashboard_card_ten.classList.add('show_important');
                    }
                }
            }, 500);
            /* moves #dashboard_card_eleven_card into #dashboard_item_eleven*/
            setTimeout(function () {
                if ('#dashboard_card_eleven') {
                    /*console.log('#dashboard_card_eleven is present and will now be moved into the dashboard housing');*/
                    var dashboard_item_eleven = document.querySelector('#dashboard_item_eleven');
                    var dashboard_card_eleven = document.querySelector('#dashboard_card_eleven');
                    var close_dashboard_item_eleven = document.querySelector('#close_dashboard_item_eleven');
                    if (dashboard_item_eleven && dashboard_card_eleven) {
                        dashboard_item_eleven.insertBefore(dashboard_card_eleven, close_dashboard_item_eleven);
                        dashboard_card_eleven.classList.add('show_important');
                    }
                }
            }, 500);
            /* moves #dashboard_card_twelve_card into #dashboard_item_twelve*/
            setTimeout(function () {
                if ('#dashboard_card_twelve') {
                    /*console.log('#dashboard_card_twelve is present and will now be moved into the dashboard housing');*/
                    var dashboard_item_twelve = document.querySelector('#dashboard_item_twelve');
                    var dashboard_card_twelve = document.querySelector('#dashboard_card_twelve');
                    var close_dashboard_item_twelve = document.querySelector('#close_dashboard_item_twelve');
                    if (dashboard_item_twelve && dashboard_card_twelve && close_dashboard_item_twelve) {
                        dashboard_item_twelve.insertBefore(dashboard_card_twelve, close_dashboard_item_twelve);
                        dashboard_card_twelve.classList.add('show_important');
                    }
                }
            }, 500);
            /* moves #dashboard_card_thirteen_card into #dashboard_item_thirteen*/
            setTimeout(function () {
                if ('#dashboard_card_thirteen') {
                    /*console.log('#dashboard_card_thirteen is present and will now be moved into the dashboard housing');*/
                    var dashboard_item_thirteen = document.querySelector('#dashboard_item_thirteen');
                    var dashboard_card_thirteen = document.querySelector('#dashboard_card_thirteen');
                    var close_dashboard_item_thirteen = document.querySelector('#close_dashboard_item_thirteen');
                    if (dashboard_item_thirteen && dashboard_card_thirteen) {
                        dashboard_item_thirteen.insertBefore(dashboard_card_thirteen, close_dashboard_item_thirteen);
                        dashboard_card_thirteen.classList.add('show_important');
                    }
                }
            }, 500);
            /* moves #dashboard_card_fourteen_card into #dashboard_item_fourteen*/
            setTimeout(function () {
                if ('#dashboard_card_fourteen') {
                    /*console.log('#dashboard_card_fourteen is present and will now be moved into the dashboard housing');*/
                    var dashboard_item_fourteen = document.querySelector('#dashboard_item_fourteen');
                    var dashboard_card_fourteen = document.querySelector('#dashboard_card_fourteen');
                    var close_dashboard_item_fourteen = document.querySelector('#close_dashboard_item_fourteen');
                    if (dashboard_item_fourteen && dashboard_card_fourteen) {
                        dashboard_item_fourteen.insertBefore(dashboard_card_fourteen, close_dashboard_item_fourteen);
                        dashboard_card_fourteen.classList.add('show_important');
                    }
                }
            }, 500);
            /* moves #dashboard_card_fifteen_card into #dashboard_item_fifteen*/
            setTimeout(function () {
                if ('#dashboard_card_fifteen') {
                    /*console.log('#dashboard_card_fifteen is present and will now be moved into the dashboard housing');*/
                    var dashboard_item_fifteen = document.querySelector('#dashboard_item_fifteen');
                    var dashboard_card_fifteen = document.querySelector('#dashboard_card_fifteen');
                    var close_dashboard_item_fifteen = document.querySelector('#close_dashboard_item_fifteen');
                    if (dashboard_item_fifteen && dashboard_card_fifteen) {
                        dashboard_item_fifteen.insertBefore(dashboard_card_fifteen, close_dashboard_item_fifteen);
                        dashboard_card_fifteen.classList.add('show_important');
                    }
                }
            }, 500);
        }

        /*eslint-enable*/
    };
});


// WEBPACK FOOTER //
// ./src/mns-core-ui-header/templates/header/js/links/sparksDashboard.js